import { useEffect } from 'react';
import { useStateValue } from '../../../../../../context/AppContext';
import {
  isInSchoolAPEvent,
  isInSchoolAPEvents,
  isInSchoolAPHybridEvent,
  isInSchoolPSATEvent,
  isInSchoolSATEvent,
} from '../../../../../../utils/event';
import '../../../../common/common.scss';
import HelpNav from '../../../../common/HelpNav';
import { CmsContent, FlowData, getConfigKey } from '../../../../common/proctorStepsTypes';
import { getStudentStatuses } from '../../../../common/utility';
import './Setup.scss';
import { WelcomePage } from './WelcomePage';
import { Room } from '../../../../../../types/Rooms';
import { GetStepDefinitions } from './StepDefinitions';
import { Navigation } from '../../../../common/rooms/details/Setup/Navigation';
import { SetupComplete } from '../../../../common/rooms/details/Setup/SetupComplete';
import { useSkipLink } from '../../../../../../hooks/useSkipLink';

interface SetupProps {
  flowData: FlowData;
  room: Room;
  cmsContent: CmsContent | undefined;
}

function Setup({ flowData, room, cmsContent }: SetupProps) {
  // Global App state
  const { orgEvent, user } = useStateValue();

  // Local vars
  const { stepNum } = flowData;
  const studentStatuses = getStudentStatuses(room?.students);

  const { steps, introStep, outerStep } = GetStepDefinitions({
    cmsContent,
    stepNum,
    room,
    isInSchoolAPEvents: isInSchoolAPEvents(orgEvent),
    isInSchoolPSATEvent: isInSchoolPSATEvent(orgEvent),
    isInSchoolSATEvent: isInSchoolSATEvent(orgEvent),
    isInSchoolAPEvent: isInSchoolAPEvent(orgEvent),
    isInSchoolAPHybridEvent: isInSchoolAPHybridEvent(orgEvent),
    configKey: getConfigKey(orgEvent),
  });

  useEffect(() => {
    // Load room capacity dynamically
    const roomCapacity = document.querySelector('.setup-step-1-seatCounts');

    if (roomCapacity) {
      (roomCapacity as HTMLElement).innerText = room?.capacity.toString();
    }
  });

  useSkipLink(room.id);

  return (
    <>
      {stepNum === introStep && (
        <WelcomePage
          room={room}
          cmsContent={cmsContent}
          user={user}
          studentStatuses={studentStatuses}
          stepNum={stepNum}
          introStep={introStep}
        />
      )}
      {stepNum === outerStep && (
        <SetupComplete
          cmsContent={cmsContent}
          room={room}
          img={<div className='setupComplete-svg step-illustration-img mt-4' />}
          imgDesc={'You&rsquo;re ready to admit students'}
          finalStepNumber={outerStep}
        />
      )}
      {stepNum > introStep && stepNum < outerStep && steps()}
      <HelpNav />
      <Navigation roomId={room.id} orgEvent={orgEvent} stepNum={stepNum} lastStep={outerStep} />
    </>
  );
}

export default Setup;
